import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const BillSettingsPageContent = lazy(() => import("./BillSettingsPageContent"));

function BillSettingsPageInternal() {
    return (
        <DefaultPage>
            <BillSettingsPageContent />
        </DefaultPage>
    );
}

export const BillSettingsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    BillSettingsPageInternal
);
